import React, { Component } from 'react';
import {
  Portlet,
  PortletBody,
  PortletHeader,
} from "../../../partials/content/Portlet";
import { Container, Row, Col, Card, Button, Badge, Accordion, Modal, Form, InputGroup, FormControl, Dropdown } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import { pmsRenewalServices } from './PMSRenewal.services';
import NotesComponent from '../../../partials/layout/NotesComponent.js';
import * as constants from '../../../constants';
import TasksListComponent from "../../../partials/layout/TasksListComponent.js";
import { connect } from 'react-redux';
import { formatDate, formatMultipleUsers, findPrimary, formatDateTime } from '../../../../_metronic/utils/utils';
import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { store } from 'react-notifications-component';
import * as Yup from 'yup';
import * as firebase from 'firebase/app';
import { DatePickerField } from '../../../partials/layout/DatePickerField';
import { Link } from 'react-router-dom';
import FilterComponent from '../../../partials/layout/FilterComponent';
import { commonServices } from '../../../../app/commonServices/commonServices';
import PMSRenewalsStatsCards from './PMSRenewalsCards.js';
import RenewalTimeline from './PmsRenewalTimeline.js';

const renewPMSSubscriptionSchema = Yup.object().shape({
  startDate: Yup.date().required('Start Date is a mandatory field'),
  endDate: Yup.date().required('End date is a mandatory field'),
  // feeRateQuantity: Yup.number().required('Rate is a mandatory field'),
  // feeRateUnit: Yup.string().required('Rate Unit is a mandatory field'),
  // feePaymentInterval: Yup.string().required('Payment Interval is a mandatory field'),
  // feePaymentMechanism: Yup.string().required('Payment Method is a mandatory field'),
  planSelected: Yup.string().required('Choosing a plan is mandatory'),
  tcfIdentifier: Yup.string()
    .when('feeRateQuantity', {
      is: (feeRateQuantity) => feeRateQuantity && feeRateQuantity > 0,
      then: Yup.string()
        .required('TCF ID is required')
    }),
  file: Yup.mixed()
    .when('feeRateQuantity', {
      is: (feeRateQuantity) => feeRateQuantity > 0,
      then: Yup.mixed().required('Service Agreement File is required.')
    }),
});

const cancelPMSSubscriptionSchema = Yup.object().shape({
  pmsRenewalWork: Yup.object().shape({
    terminalRemarks: Yup.string().optional(),
    terminalRemarksCategory: Yup.string().required('Remarks category is a mandatory field')
  })
})

const pmsProposalSchema = Yup.object().shape({
  pmsProposal: Yup.object().shape({
    ownerId: Yup.number().required("Owner is required"),
    revisedRent: Yup.number().required("Revised Rent is required"),
    newSubscriptionStartDate: Yup.string().required("New Lease Start Date is required"),
    newSubscriptionEndDate: Yup.string().required("Renewal Lease End Date is required"),
    planSelected: Yup.string().required('Choosing a plan is mandatory'),
    // feeRateQuantity: Yup.number().required("Service Fee is required"),
    // feeRateUnit: Yup.string().required(),
    // feePaymentInterval: Yup.string().required(),
    // feePaymentMechanism: Yup.string().required()
  })
});
class PMSRenewals extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props,
      isFetching: false,
      showCancelPMSSubscriptionModal: false,
      showRenewPMSSubscriptionModal: false,
      showNotifyModal: false,
      showMoveOutModal: false,
      showProposalModal: false,
      page: 1,
      total: undefined,
      offset: 0,
      limit: 10,
      state: !props.houseIdFromPropertyProfile ? ['OPEN'] : undefined,
      renewalStage: undefined,
      terminalStatusForRenewal: undefined,
      propertyManagementStatus: ['YES'],
      riskStatus: undefined,
      requestedFilters: ['terminalStatusForRenewal', 'propertyManagementStatus', 'riskStatus', 'sortOrder'],
      renewalStats: {
        opportunities: 0,
        renewalsDone: 0,
        renewalsIntimated: 0,
        proposalsSent: 0,
        proposalsAccepted: 0,
        proposalsRejected: 0,
        moveOuts: 0,
        discontinued: 0,
      },

    }
  }

  static getDerivedStateFromProps(props, state) {
    let result = {}
    if (state.accordionData?.terminalStatusForRenewal !== props.houseInspectionWork?.terminalStatusForRenewal) {
      result.houseInspectionWork = props.accordionData
    }
    return Object.keys(result).length > 0 ? result : null;
  }

  async componentDidMount() {
    await this.getAllPMSRenewalWorks();
    await this.getCities();
    await this.getPropertyManagers();
  }

  getPropertyManagers = async () => {
    const data = {
      userRoleCodes: ['PROPERTY_MANAGER'],
    }
    const result = await commonServices.getUserListData(data);
    if (result && result.status === 200) {
      await this.setState({ propertyManagers: result.data.users })
    }
  }

  getCities = async () => {
    const { cityIds } = this.state;
    const data = {
      pmsOperationStatus: 'YES'
    }
    const result = await commonServices.getCities(data);
    if (result && result.status === 200) {
      const cities = result?.data?.cities;
      const formattedCities = commonServices.formatCities(cities);
      let preSelectedCities = null;
      if (this.state.cityIds?.length > 0) {
        preSelectedCities = commonServices.preSelectCities(formattedCities, cityIds);
      }
      this.setState({ formattedCities });
      preSelectedCities && this.setState({ preSelectedCities });
    }
  }

  getAllPMSRenewalWorks = async () => {
    this.setState({ isFetching: true })
    const { offset, limit, terminalStatusForRenewal, houseIdFromPropertyProfile, cityIds, minimumSourcePmsSubscriptionEndDate,
      maximumSourcePmsSubscriptionEndDate, maximumLatestNoteCreatedAt, propertyManagerId, state, propertyManagementStatus, renewalStage, riskStatus, sortOrder } = this.state;
    const data = {
      state: (renewalStage) ? undefined : ((state && state[0]) || undefined),
      renewalStage: renewalStage,
      terminalStatus: (terminalStatusForRenewal && terminalStatusForRenewal[0]) || undefined,
      cityIds,
      sortOrder: sortOrder || undefined,
      minimumSourcePmsSubscriptionEndDate,
      maximumSourcePmsSubscriptionEndDate, maximumLatestNoteCreatedAt,
      propertyManagementStatus: (propertyManagementStatus && propertyManagementStatus[0]) || undefined,
      riskStatus: (riskStatus && riskStatus[0]) || undefined,
      propertyManagerId: propertyManagerId !== '0' ? propertyManagerId : undefined,
      houseId: houseIdFromPropertyProfile,
      include: houseIdFromPropertyProfile ? undefined : ['PROPERTY_MANAGER'],
      offset,
      limit,
    }
    const result = await pmsRenewalServices.getAllPMSRenewalWorks(data)
    if (result && result.status === 200) {
      const totalCount = result.headers['x-total-count'];
      const totalPageNo = Math.ceil(result.headers['x-total-count'] / limit);
      await this.setState({
        pmsRenewals: result.data.pmsRenewalWorks,
        total: (totalPageNo === 0) ? 1 : totalPageNo,
        totalCount,
        renewalStats: result.data.renewalStats
      })
      if (houseIdFromPropertyProfile) {
        if (this.state.pmsRenewals) {
          this.state.pmsRenewals.forEach((pmsRenewal) => {
            if (pmsRenewal.state === "OPEN") {
              this.props.updateNewPMSSubscriptionButtonStatus(true);
            }

          })
        }
      }
    }
    this.setState({ isFetching: false })
  }

  getPMSRenewalWorkById = async (id) => {
    const result = await pmsRenewalServices.getPMSRenewalWorkById(id)
    if (result && result.status === 200) {
      await this.setState({ accordionData: result.data.pmsRenewalWork })
      this.state.pmsRenewals.forEach(renew => {
        if (this.state.accordionData?.id === renew?.id) {
          renew.notes = this.state.accordionData.notes;
          renew.notes.reverse();
        }
      })
      this.forceUpdate();
    }
  }

  getPMSSubscriptionStatusBadge = (renewalStatus) => {
    if (renewalStatus === 'OPEN') return <Badge variant="success" title="Open">O</Badge>
    if (renewalStatus === 'DISCONTINUED') return <Badge variant="danger" title="Cancelled">C</Badge>
    if (renewalStatus === 'RENEWED') return <Badge variant="info" title="Renewed">R</Badge>
    if (renewalStatus === 'MOVE_OUT') return <Badge variant="warning" title="Move Out">M</Badge>
  }

  handleCancelPMSSubscriptionButtonClick = async () => {
    await this.setState(state => ({ showCancelPMSSubscriptionModal: !state.showCancelPMSSubscriptionModal }));
    if (this.state.showCancelPMSSubscriptionModal) {
      firebase.analytics().logEvent("cancel_pms_subscription_button_click", { description: "Cancel PMS Subscription Button Clicked" });
    }
  }

  handleNotifyButtonClick = () => {
    this.setState(state => ({ showNotifyModal: !state.showNotifyModal }));
  }

  handleMarkMoveOutButtonClick = () => {
    this.setState(state => ({ showMoveOutModal: !state.showMoveOutModal }));
  }

  handlePMSProposalButtonClick = () => {
    this.setState(state => ({ showProposalModal: !state.showProposalModal }));
  }
  handleRenewPMSSubscriptionButtonClick = async () => {
    await this.setState(state => ({ showRenewPMSSubscriptionModal: !state.showRenewPMSSubscriptionModal }));
    if (this.state.showRenewPMSSubscriptionModal) {
      firebase.analytics().logEvent("renew_pms_subscription_button_click", { description: "Renew PMS Subscription Button Clicked" });
    }
  }

  /**
 * Method to resend the last PMS proposal email to the customer
 * @param {*} id - latestPmsProposal id
 */
  handleResendLastPMSProposal = async (id) => {
    const result = await pmsRenewalServices.resendLastPMSProposal(id);
    if (result && result.status === 201) {
      store.addNotification({
        title: "Success!",
        message: "Proposal resent successfully!",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
          showIcon: true,
          pauseOnHover: true
        }
      });
    }
  }

  handleAccordionClick = async (id) => {
    const { prevId } = this.state;
    if (prevId !== id) {
      this.setState({ prevId: id });
      await this.getPMSRenewalWorkById(id);
      firebase.analytics().logEvent("pms_renewals_details_view_click", { description: "PMS Renewals Details View Clicked", pmsRenewalId: id });
    }
  }

  handleChildData = async (renewalWorkId) => {
    await this.getPMSRenewalWorkById(renewalWorkId);
  }

  onPageChange = async (page) => {
    const { limit } = this.state;
    const offset = (limit * (page - 1));
    await this.setState({ page, offset });
    await this.getAllPMSRenewalWorks();
  }

  handleFilterChildData = async (childData) => {
    if (childData) {
      this.setState({ ...childData });
      await this.resetPage();
      await this.getAllPMSRenewalWorks();
      await this.getCities();
      await this.getPropertyManagers();
      firebase.analytics().logEvent("apply_filter_button_click", { description: "Apply Filter Button Clicked", filterComponent: 'PMS Renewals' });
    }
  }

  resetPage = async () => {
    await this.setState({
      page: 1,
      offset: 0,
      //limit: 10,
    });
  }

  validateTCFId = (currentText) => {
    let error;
    if (currentText && currentText.length === 17) {
      let prefixPart = currentText.substr(0, 4);
      if (prefixPart === 'TCF-') {
        let datePart = currentText.substr(4, 8);
        let yearPart = datePart.substr(0, 4);
        let monthPart = datePart.substr(4, 2);
        let dayPart = datePart.substr(6, 2);
        let tcfDate = new Date(yearPart, (Number(monthPart) - 1), dayPart);
        let currentDate = new Date();
        if (tcfDate && (tcfDate <= currentDate)) {
          console.log("seems fine");
          let finalSerialPartSeparator = currentText.substr(12, 1);
          if (finalSerialPartSeparator === "-") {
            let finalSerialPart = currentText.substr(13, 4);
            if (Number(finalSerialPart)) {
              console.log("TCF ID seems fine");
            } else {
              error = "TCF ID is invalid";
            }
          } else {
            error = "TCF ID is invalid";
          }
        } else {
          error = "TCF ID is invalid";
        }
      } else {
        error = "TCF ID is invalid";
      }
    } else {
      error = "TCF ID should be 17 characters long";
    }
    return error;
  }
  calculateDueDays = (endDate) => {
    const today = new Date();
    const end = new Date(endDate);

    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  handlePlanChange = async (e, setFieldValue, validateForm, prefix = "") => {
    const field = (name) => prefix ? `${prefix}.${name}` : name;
    if (e.target.validity.valid) {
      switch (e.target.value) {

        case "freePlan":
          setFieldValue(field("feeRateQuantity"), "0");
          setFieldValue(field("feeRateUnit"), constants.FEE_RATE_UNIT[1]);
          setFieldValue(field("feePaymentInterval"), constants.FEE_PAYMENT_INTERVAL[0]);
          setFieldValue(field("feePaymentMechanism"), constants.FEE_PAYMENT_MECHANISM[0]);
          break;

        case "eightPercentPlan":
          setFieldValue(field("feeRateQuantity"), "8");
          setFieldValue(field("feeRateUnit"), constants.FEE_RATE_UNIT[0]);
          setFieldValue(field("feePaymentInterval"), constants.FEE_PAYMENT_INTERVAL[0]);
          setFieldValue(field("feePaymentMechanism"), constants.FEE_PAYMENT_MECHANISM[2]);
          break;

        case "fixedAmountFromRentPlan":
          setFieldValue(field("feeRateUnit"), constants.FEE_RATE_UNIT[1]);
          setFieldValue(field("feePaymentInterval"), constants.FEE_PAYMENT_INTERVAL[0]);
          setFieldValue(field("feePaymentMechanism"), constants.FEE_PAYMENT_MECHANISM[2]);
          break;

        case "customPlan":
          setFieldValue(field("feeRateUnit"), constants.FEE_RATE_UNIT[0]);
          setFieldValue(field("feePaymentInterval"), constants.FEE_PAYMENT_INTERVAL[0]);
          setFieldValue(field("feePaymentMechanism"), constants.FEE_PAYMENT_MECHANISM[2]);
          break;

        case "fullAmountPlan":
          setFieldValue(field("feeRateUnit"), constants.FEE_RATE_UNIT[1]);
          setFieldValue(field("feePaymentInterval"), constants.FEE_PAYMENT_INTERVAL[1]);
          setFieldValue(field("feePaymentMechanism"), constants.FEE_PAYMENT_MECHANISM[1]);
          break;

        default:
          break;
      }

      validateForm();
    }
  };

  handleMoveOutRenewal = async () => {
    const { accordionData } = this.state;

    let data = {
      pmsRenewalWork: {
        terminalStatus: "MOVE_OUT"
      }
    }
    const result = await pmsRenewalServices.markRenewalAsMoveOut(accordionData.id, data);
    if (result?.status === 200) {
      store.addNotification({
        title: "Success!",
        message: "Renewal marked as Move-Out successfully!",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });

      this.setState({
        showMoveOutModal: false,
      });

      this.getAllPMSRenewalWorks();
    }
  };

  getRenewalStatusBadge = (renewal) => {
    if (renewal.state === "RENEWED") {
      return <Badge variant="success" className="px-2 py-1">Renewed</Badge>;
    }
    if (renewal.state === "DISCONTINUED") {
      return <Badge variant="danger" className="px-2 py-1">Lost</Badge>;
    }

    if (renewal.state === "MOVE_OUT") {
      return <Badge variant="warning" className="px-2 py-1">Move Out</Badge>;
    }
    if (renewal.latestPmsProposal?.status === "REJECTED") {
      return <Badge variant="danger" className="px-2 py-1">Proposal Rejected</Badge>;
    }
    if (renewal.latestPmsProposal?.status === "ACCEPTED") {
      return <Badge variant="success" className="px-2 py-1">Proposal Accepted</Badge>;
    }
    if (renewal.latestPmsProposal?.status === "SENT") {
      return <Badge variant="info" className="px-2 py-1">Proposal Sent</Badge>;
    }
    if (renewal.isNotify === true) {
      return <Badge variant="warning" className="px-2 py-1">Renewal Intimated</Badge>;
    }

    if (renewal.isNotify === null) {
      return <Badge variant="secondary" className="px-2 py-1">Start Intimation</Badge>;
    }

    return null;
  }
  deriveSelectedPlan = (proposal) => {
    if (!proposal) return undefined;

    const { feeRateQuantity, feeRateUnit, feePaymentMechanism, paymentChargeMode } = proposal;

    if (!paymentChargeMode || paymentChargeMode === "FREE_TRIAL") {
      return 'freePlan';
    }

    if (paymentChargeMode === constants.PAYMENT_CHARGE_MODE[1]) {
      // Invoice Full Amount
      return 'fullAmountPlan';
    }

    if (paymentChargeMode === constants.PAYMENT_CHARGE_MODE[0]) {
      // Deduct from Rent
      if (feeRateUnit === constants.FEE_RATE_UNIT[0] && feeRateQuantity === '8') {
        return 'eightPercentPlan';
      }
      if (feeRateUnit === constants.FEE_RATE_UNIT[1]) {
        return 'fixedAmountFromRentPlan';
      }
      if (feeRateUnit === constants.FEE_RATE_UNIT[0]) {
        return 'customPlan';
      }
    }

    return undefined;
  };

  handleRiskToggle = async (renewal, isRisk) => {
    try {
      if (this.state.updatingRiskId === renewal.id) {
        return;
      }

      this.setState({
        updatingRiskId: renewal.id
      });
      const result = await pmsRenewalServices.notifyCustomer(
        renewal.id,
        {
          isRisk: isRisk
        }
      );

      if (result && result.status === 200) {
        store.addNotification({
          title: "Success!",
          message: `Risk status ${isRisk ? "enabled" : "disabled"}.`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
            showIcon: true,
            pauseOnHover: true
          }
        });

        this.getAllPMSRenewalWorks();
      }
    } catch (error) {
      console.log("Error updating risk status", error);
    } finally {
      this.setState({
        updatingRiskId: null
      });
    }
  };


  render() {
    const { isFetching, terminalStatusForRenewal, pmsRenewals, accordionData, page, total, totalCount, houseIdFromPropertyProfile,
      formattedCities, preSelectedCities, minimumSourcePmsSubscriptionEndDate, propertyManagementStatus, riskStatus,
      maximumSourcePmsSubscriptionEndDate, maximumLatestNoteCreatedAt, propertyManagers,
      propertyManagerId, requestedFilters, state, renewalStats } = this.state;
    let showPagination = false;
    const isAcceptedProposal = accordionData?.latestPmsProposal?.status === "ACCEPTED";
    if (isFetching) {
      return <p>{constants.LOADING_DATA}</p>
    }
    if (total) { showPagination = total !== 0 && total !== 1; }
    let taskAssigneeData = [];
    taskAssigneeData.push(this.props.userDetails)
    return (
      <>
        <Container fluid key={'c' + 1}>
          <Portlet fluidHeight={true}>
            <PortletHeader title={`PMS Renewals (${totalCount || 0})`} />
            <PortletBody className="">
              {!houseIdFromPropertyProfile && <PMSRenewalsStatsCards
                stats={renewalStats}
              />}
              <FilterComponent
                requestedFilters={requestedFilters}
                //state={state}
                terminalStatusForRenewal={terminalStatusForRenewal}
                formattedCities={!houseIdFromPropertyProfile ? formattedCities : undefined}
                preSelectedCities={!houseIdFromPropertyProfile ? preSelectedCities : undefined}
                minimumSourcePmsSubscriptionEndDate={minimumSourcePmsSubscriptionEndDate}
                maximumSourcePmsSubscriptionEndDate={maximumSourcePmsSubscriptionEndDate}
                propertyManagers={!houseIdFromPropertyProfile ? propertyManagers : undefined}
                propertyManagerId={!houseIdFromPropertyProfile ? propertyManagerId : undefined}
                maximumLatestNoteCreatedAt={maximumLatestNoteCreatedAt}
                propertyManagementStatus={propertyManagementStatus}
                riskStatus={riskStatus}
                recordsPerPage={constants.RECORDS_PER_PAGE}
                selectedRecordValue={this.state.limit}
                pmsRenewalStagesData={constants.RENEWAL_STAGE_STATUS}
                selectedPmsRenewalStage={this.state.renewalStage}
                filterParentCallback={this.handleFilterChildData}
              />
              <Row>
                <Col xs={12}>
                  <Accordion>
                    <Card>
                      {pmsRenewals && pmsRenewals.length === 0 && <p>{constants.ZERO_DATA}</p>}
                      {pmsRenewals && pmsRenewals.length > 0 &&
                        <Card.Header>
                          <Row className="py-2 px-3 azuro-table-header">
                            <Col md={1}><strong>Status</strong></Col>
                            {!houseIdFromPropertyProfile && <Col md={3}><strong>Property</strong></Col>}
                            <Col md={houseIdFromPropertyProfile ? 2 : 2}><strong>Owner</strong></Col>
                            <Col md={houseIdFromPropertyProfile ? 2 : 1}><strong>PMS Ends On</strong></Col>
                            <Col md={houseIdFromPropertyProfile ? 2 : 1}><strong>Due in</strong></Col>
                            {/* <Col md={2}><strong>Latest Update</strong></Col> */}
                            <Col md={1}><strong>Last Rate</strong></Col>
                            {/* <Col md={2}><strong>Last Frequency</strong></Col> */}
                            <Col md={3} className="renewal-status-column d-flex align-items-center justify-content-between"><strong>Renewal Status</strong></Col>
                          </Row>
                        </Card.Header>}
                    </Card>
                    {pmsRenewals && pmsRenewals.map(renewal =>
                      <Card key={renewal.id}>
                        <Accordion.Toggle as={Card.Header} eventKey={renewal.id} className="row py-2 azuro-table-row"
                          onClick={() => { this.handleAccordionClick(renewal.id) }}>
                          <Col md={1} className="d-flex flex-row">
                            {/* <span className="pr-3">{this.getPMSSubscriptionStatusBadge(renewal.state)}</span> */}
                            <span className="pr-3">
                              <Form.Check
                                type="switch"
                                id={`risk-switch-${renewal.id}`}
                                label={renewal.isRisk ? "Risk" : "No Risk"}
                                checked={renewal.isRisk === true}
                                onChange={(e) =>
                                  this.handleRiskToggle(renewal, e.target.checked)
                                }
                                className="risk-switch"
                              />
                            </span>
                          </Col>
                          {!houseIdFromPropertyProfile && <Col md={3} className="d-flex flex-row">
                            {renewal.house && <span><Link to={`/property-profile/${renewal.house.id}`}>
                              <span>{renewal.house.formattedHouseName}</span>
                            </Link> <br />
                              <span className="small text-muted">{renewal.house.propertyManager ? `PM: ${(renewal.house.propertyManager && renewal.house.propertyManager.fullName)}` : `PM: Not Assigned`}</span>
                            </span>}
                          </Col>}

                          <Col md={houseIdFromPropertyProfile ? 2 : 2}>
                            {renewal.house && formatMultipleUsers((renewal.house && renewal.house.owners) || [])}
                            {renewal.house && renewal.house.owners && findPrimary(renewal.house.owners) && findPrimary(findPrimary(renewal.house.owners).phoneNumbers) &&
                              ` (+${findPrimary(findPrimary(renewal.house.owners).phoneNumbers).countryCode} ${findPrimary(findPrimary(renewal.house.owners).phoneNumbers).number})`
                            }
                          </Col>
                          <Col md={houseIdFromPropertyProfile ? 2 : 1}>{formatDate(renewal.sourcePmsSubscription && renewal.sourcePmsSubscription.endDate)}</Col>
                          <Col md={houseIdFromPropertyProfile ? 2 : 1}>{renewal.sourcePmsSubscription && this.calculateDueDays(renewal.sourcePmsSubscription.endDate)}</Col>
                          {/* <Col md={2}>
                            {(renewal.notes.length === 0) ? "No Updates" : (formatDate(renewal.notes[0].createdAt)) + " : " + (renewal.notes[0].content)}
                          </Col> */}
                          <Col md={1}>
                            {renewal.sourcePmsSubscription && renewal.sourcePmsSubscription.formattedRate}
                          </Col>
                          {/* <Col md={2} className="d-flex justify-content-between">
                            <span>{renewal.sourcePmsSubscription && renewal.sourcePmsSubscription.feePaymentInterval}</span>
                            <i className="flaticon2-sort"></i>
                            <Link to={`/property-profile/${renewal.house.id}`}>
                              <Button size='sm' variant='clean'><i className="flaticon-home-1"></i></Button>
                            </Link>
                          </Col> */}
                          <Col md={3} className="renewal-status-column d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-end" style={{ gap: '10px' }}>

                              <div style={{ minWidth: 110, textAlign: 'right' }}>
                                {this.getRenewalStatusBadge(renewal)}
                              </div>

                              <div style={{ minWidth: 140 }}>
                                {/* Start Intimation */}
                                {(renewal.isNotify === null && renewal.state === 'OPEN') && (
                                  <div onClick={(e) => {
                                    e.stopPropagation()
                                    this.handleAccordionClick(renewal.id);
                                  }}>
                                    <Dropdown>
                                      <Dropdown.Toggle variant="outline-primary" size="sm">
                                        Start Intimation
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu className="px-3 py-2">
                                        <Dropdown.Item
                                          className="mr-2"
                                          variant="primary"
                                          size="sm"
                                          onClick={() => this.handleNotifyButtonClick(renewal.id)}
                                        >
                                          Start Initimation
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="mr-2"
                                          variant="primary"
                                          size="sm"
                                          onClick={() => this.handleMarkMoveOutButtonClick(renewal.id)}
                                        >
                                          Mark Move-out
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          className="mr-2"
                                          variant="primary"
                                          size="sm"
                                          onClick={() => this.handleCancelPMSSubscriptionButtonClick(renewal.id)}
                                        >
                                          Discontinue
                                        </Dropdown.Item>

                                        {/* <Dropdown.Item
                                          variant="success"
                                          size="sm"
                                          onClick={() => this.handleRenewPMSSubscriptionButtonClick(renewal.id)}
                                        >
                                          Renew
                                        </Dropdown.Item> */}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                )}

                                {/* Discontinued - View Lost Reason button */}
                                {renewal?.state === "DISCONTINUED" && (
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.setState({
                                        selectedLease: renewal,
                                        showViewReasonModal: true,
                                        lostOrHold: "LOST"
                                      })
                                    }}
                                  >
                                    View Lost Reason
                                  </Button>
                                )}

                                {/* Open, already intimated */}
                                {(renewal?.state === "OPEN" && renewal.isNotify !== null) && (
                                  <div onClick={(e) => {
                                    e.stopPropagation()
                                    this.handleAccordionClick(renewal.id);
                                  }}>
                                    <Dropdown>
                                      <Dropdown.Toggle variant="outline-primary" size="sm">
                                        Update Renewal
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu className="px-3 py-2">
                                        {(renewal.latestPmsProposal?.status === "REJECTED" || !renewal.latestPmsProposal) && (
                                          <Dropdown.Item onClick={() => this.handlePMSProposalButtonClick(renewal.id)}>
                                            Send Proposal
                                          </Dropdown.Item>
                                        )}
                                        {(renewal.latestPmsProposal?.status === "SENT") && (
                                          <Dropdown.Item onClick={() => this.handleResendLastPMSProposal(renewal.latestPmsProposal?.id)}>
                                            Resend Last Proposal
                                          </Dropdown.Item>
                                        )}
                                        <Dropdown.Item
                                          className="mr-2"
                                          variant="primary"
                                          size="sm"
                                          onClick={() => this.handleCancelPMSSubscriptionButtonClick(renewal.id)}
                                        >
                                          Discontinue
                                        </Dropdown.Item>

                                        {renewal.latestPmsProposal?.status === "ACCEPTED" && (<Dropdown.Item
                                          variant="success"
                                          size="sm"
                                          onClick={() => this.handleRenewPMSSubscriptionButtonClick(renewal.id)}
                                        >
                                          Renew
                                        </Dropdown.Item>)}
                                        <Dropdown.Item
                                          className="mr-2"
                                          variant="primary"
                                          size="sm"
                                          onClick={() => this.handleMarkMoveOutButtonClick(renewal.id)}
                                        >
                                          Mark Move-out
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </div>
                                )}
                              </div>

                            </div>
                          </Col>
                          {/* <Col md={2} className="d-flex justify-content-between">
                            <span>{renewal.sourcePmsSubscription && renewal.sourcePmsSubscription.feePaymentInterval}</span>
                            <i className="flaticon2-sort"></i>
                            <Link to={`/property-profile/${renewal.house.id}`}>
                              <Button size='sm' variant='clean'><i className="flaticon-home-1"></i></Button>
                            </Link>
                          </Col> */}
                        </Accordion.Toggle>

                        {accordionData && (accordionData.id === renewal.id) &&
                          <Accordion.Collapse eventKey={renewal.id}>
                            <Card.Body>
                              <RenewalTimeline renewal={renewal} />
                              <TasksListComponent
                                tasks={accordionData.tasks || []} allowAddTasks={
                                  renewal.state && renewal.state === 'OPEN'
                                }
                                renewalWorkId={renewal.id}
                                houseId={renewal?.house?.id}
                                parentCallback={this.handleChildData}
                                // approverData={userData}
                                approverData={taskAssigneeData && taskAssigneeData.length > 0 && taskAssigneeData}
                              />
                              <NotesComponent notes={accordionData.notes || []}
                                allowAddNotes={
                                  renewal.state && renewal.state === 'OPEN'
                                }
                                renewalWorkId={renewal.id}
                                parentCallback={this.handleChildData}
                              />
                              <Row className="mb-4">
                                <Col xs={12} className="text-right">
                                  {/* {renewal.state === 'OPEN' && <>
                                    <Button className='mr-2' variant="primary" size="sm" onClick={() => this.handleCancelPMSSubscriptionButtonClick(renewal.id)}>Discontinue</Button>
                                    <Button variant="success" size="sm" onClick={() => this.handleRenewPMSSubscriptionButtonClick(renewal.id)}>Renew</Button>
                                  </>} */}
                                  {/*renewal.state === 'CANCELLED' && <Button variant="primary" size="sm">Undo</Button>*/}
                                </Col>
                              </Row>
                            </Card.Body>
                          </Accordion.Collapse>
                        }
                      </Card>
                    )
                    }
                  </Accordion>
                </Col>
              </Row>
              {/* Code for pagination */}
              {showPagination && showPagination && < UltimatePagination
                currentPage={page}
                totalPages={total}
                onChange={this.onPageChange}
                boundaryPagesRange={0}
                hidePreviousAndNextPageLinks={true}
                hideFirstAndLastPageLinks={page !== 1 && page !== total ? false : true}
              />}
            </PortletBody>
          </Portlet>
        </Container>

        <Modal backdrop="static" keyboard={false} key={'m' + 1} show={this.state.showCancelPMSSubscriptionModal} onHide={this.handleCancelPMSSubscriptionButtonClick}>
          <Modal.Header closeButton>
            <Modal.Title>Discontinue Service</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                pmsRenewalWork: {
                  terminalRemarks: undefined,
                  terminalRemarksCategory: "",
                }
              }}
              validationSchema={cancelPMSSubscriptionSchema}
              onSubmit={async (values) => {
                const result = await pmsRenewalServices.discontinuePMSSubscription(accordionData && accordionData.id, values);
                if (result && result.status === 200) {
                  store.addNotification({
                    title: "Success!",
                    message: `PMS Subscription Cancelled!`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 5000,
                      onScreen: true,
                      showIcon: true,
                      pauseOnHover: true
                    }
                  });
                  this.setState(state => ({ showCancelPMSSubscriptionModal: !state.showCancelPMSSubscriptionModal }));
                  this.getAllPMSRenewalWorks();
                }
              }
              }
            >
              {
                ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) =>
                (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <Form.Group controlId='pmsRenewalWork.terminalRemarksCategory'>
                          <Form.Label>Reason</Form.Label>
                          <Form.Control as='select' name='pmsRenewalWork.terminalRemarksCategory' onChange={handleChange} onBlur={handleBlur} value={values.pmsRenewalWork.terminalRemarksCategory}>
                            <option value="">{constants.DEFAULT_OPTION}</option>
                            <option value="Owner not aligned with services">Owner not aligned with services</option>
                            <option value="Personal Use">Personal Use</option>
                            <option value="Re-Rented by Local Broker/Owner">Re-Rented by Local Broker/Owner</option>
                            <option value="Escalated">Escalated</option>
                          </Form.Control>
                          {errors.pmsRenewalWork && errors.pmsRenewalWork.terminalRemarksCategory && touched.pmsRenewalWork && touched.pmsRenewalWork.terminalRemarksCategory && <Form.Text className='text-danger'>
                            {errors.pmsRenewalWork.terminalRemarksCategory}</Form.Text>}
                        </Form.Group>
                      </Col>
                      <Col xs={12}>
                        <Form.Group controlId="pmsRenewalWork.terminalRemarks">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control as="textarea" rows="3" name="pmsRenewalWork.terminalRemarks" onChange={handleChange} onBlur={handleBlur} value={values.pmsRenewalWork.terminalRemarks} />
                          {errors.pmsRenewalWork && errors.pmsRenewalWork.terminalRemarks && touched.pmsRenewalWork && touched.pmsRenewalWork.terminalRemarks && <Form.Text className="text-danger">
                            {errors.pmsRenewalWork.terminalRemarks}
                          </Form.Text>}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} className="text-right">
                        <Button variant="secondary" className="mr-2" onClick={this.handleCancelPMSSubscriptionButtonClick}>
                          Cancel
                        </Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                          {isSubmitting ? 'Saving...' : 'Save'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )
              }
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal backdrop="static" keyboard={false} key={'m' + 2} show={this.state.showRenewPMSSubscriptionModal} onHide={this.handleRenewPMSSubscriptionButtonClick}>
          <Modal.Header closeButton>
            <Modal.Title>Renew Service</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              enableReinitialize
              initialValues={{
                startDate: isAcceptedProposal
                  ? accordionData?.latestPmsProposal?.newSubscriptionStartDate
                  : undefined,
                endDate: isAcceptedProposal
                  ? accordionData?.latestPmsProposal?.newSubscriptionEndDate
                  : undefined,
                feeRateQuantity: isAcceptedProposal
                  ? accordionData?.latestPmsProposal?.feeRateQuantity
                  : undefined,
                feeRateUnit: isAcceptedProposal
                  ? accordionData?.latestPmsProposal?.feeRateUnit
                  : undefined,
                feePaymentInterval: isAcceptedProposal
                  ? accordionData?.latestPmsProposal?.feePaymentInterval
                  : undefined,
                feePaymentMechanism: isAcceptedProposal
                  ? accordionData?.latestPmsProposal?.feePaymentMechanism
                  : undefined,
                paymentChargeMode: isAcceptedProposal
                  ? (accordionData?.latestPmsProposal?.paymentChargeMode || "FREE_TRIAL")
                  : "FREE_TRIAL",

                planSelected: isAcceptedProposal
                  ? this.deriveSelectedPlan(accordionData?.latestPmsProposal)
                  : undefined,
                tcfIdentifier: isAcceptedProposal
                  ? accordionData?.latestPmsProposal?.tcfIdentifier
                  : undefined,
                file: undefined,
                feeRateQuantityFixed: isAcceptedProposal && this.deriveSelectedPlan(accordionData?.latestPmsProposal) === 'fixedAmountFromRentPlan'
                  ? accordionData?.latestPmsProposal?.feeRateQuantity
                  : undefined,

                feeRateQuantityCustom: isAcceptedProposal && this.deriveSelectedPlan(accordionData?.latestPmsProposal) === 'customPlan'
                  ? accordionData?.latestPmsProposal?.feeRateQuantity
                  : undefined,

                feeRateQuantityFull: isAcceptedProposal && this.deriveSelectedPlan(accordionData?.latestPmsProposal) === 'fullAmountPlan'
                  ? accordionData?.latestPmsProposal?.feeRateQuantity
                  : undefined,
              }}
              validationSchema={renewPMSSubscriptionSchema}
              onSubmit={
                async (values) => {
                  switch (values.planSelected) {
                    case 'freePlan':
                      values.feeRateQuantity = '0';
                      values.feeRateUnit = constants.FEE_RATE_UNIT[1];
                      values.feePaymentInterval = constants.FEE_PAYMENT_INTERVAL[0];
                      values.feePaymentMechanism = constants.FEE_PAYMENT_MECHANISM[0];
                      break;

                    case 'eightPercentPlan':
                      values.feeRateQuantity = '8';
                      values.feeRateUnit = constants.FEE_RATE_UNIT[0];
                      values.feePaymentInterval = constants.FEE_PAYMENT_INTERVAL[0];
                      values.feePaymentMechanism = constants.FEE_PAYMENT_MECHANISM[2];
                      break;

                    case 'fixedAmountFromRentPlan':
                      values.feeRateQuantity = values.feeRateQuantityFixed;
                      values.feeRateUnit = constants.FEE_RATE_UNIT[1];
                      values.feePaymentInterval = constants.FEE_PAYMENT_INTERVAL[0];
                      values.feePaymentMechanism = constants.FEE_PAYMENT_MECHANISM[2];
                      break;

                    case 'customPlan':
                      values.feeRateQuantity = values.feeRateQuantityCustom;
                      values.feeRateUnit = constants.FEE_RATE_UNIT[0];
                      values.feePaymentInterval = constants.FEE_PAYMENT_INTERVAL[0];
                      values.feePaymentMechanism = constants.FEE_PAYMENT_MECHANISM[2];
                      break;

                    case 'fullAmountPlan':
                      values.feeRateQuantity = values.feeRateQuantityFull;
                      values.feeRateUnit = constants.FEE_RATE_UNIT[1];
                      values.feePaymentInterval = constants.FEE_PAYMENT_INTERVAL[1];
                      values.feePaymentMechanism = constants.FEE_PAYMENT_MECHANISM[1];
                      break;
                    default: break;
                  }

                  delete values.feeRateQuantityFixed;
                  delete values.feeRateQuantityCustom;
                  delete values.feeRateQuantityFull;
                  delete values.planSelected;

                  if (values.paymentChargeMode === "FREE_TRIAL") {
                    values.paymentChargeMode = "";
                  }

                  let formData = new FormData();
                  values.file && formData.append('resultantPmsSubscription[file]', values.file);
                  values.startDate && formData.append('resultantPmsSubscription[startDate]', values.startDate);
                  values.endDate && formData.append('resultantPmsSubscription[endDate]', values.endDate);
                  values.feeRateQuantity && formData.append('resultantPmsSubscription[feeRateQuantity]', values.feeRateQuantity);
                  values.feeRateUnit && formData.append('resultantPmsSubscription[feeRateUnit]', values.feeRateUnit);
                  values.feePaymentInterval && formData.append('resultantPmsSubscription[feePaymentInterval]', values.feePaymentInterval);
                  values.feePaymentMechanism !== undefined && formData.append('resultantPmsSubscription[feePaymentMechanism]', values.feePaymentMechanism ? values.feePaymentMechanism : '');
                  values.paymentChargeMode !== undefined && formData.append('resultantPmsSubscription[paymentChargeMode]', values.paymentChargeMode ? values.paymentChargeMode : '');
                  values.tcfIdentifier !== undefined && formData.append('resultantPmsSubscription[tcfIdentifier]', values.tcfIdentifier ? values.tcfIdentifier : '');

                  const result = await pmsRenewalServices.renewPMSSubscription(accordionData && accordionData.id, formData);
                  if (result && result.status === 201) {
                    store.addNotification({
                      title: "Success!",
                      message: `PMS Subscription Renewed!`,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                        duration: 5000,
                        onScreen: true,
                        showIcon: true,
                        pauseOnHover: true
                      }
                    });
                    this.setState(state => ({ showRenewPMSSubscriptionModal: !state.showRenewPMSSubscriptionModal }));
                    this.getAllPMSRenewalWorks();
                  }
                }
              }
            >
              {
                ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, validateForm }) =>
                (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={6}>
                        <Form.Group controlId="startDate">
                          <DatePickerField
                            className='form-control'
                            autoComplete='off'
                            label='Start Date'
                            isMandatory={true}
                            dateFormat='MMMM d, yyyy'
                            name='startDate'
                            value={values.startDate}
                            onChange={setFieldValue}
                            disabled={isAcceptedProposal}
                          />
                          {errors.startDate && touched.startDate && <Form.Text className="text-danger">
                            {errors.startDate}
                          </Form.Text>}
                        </Form.Group>
                      </Col>
                      <Col xs={6}>
                        <Form.Group controlId="endDate">
                          <DatePickerField
                            className='form-control'
                            autoComplete='off'
                            label='End Date'
                            isMandatory={true}
                            dateFormat='MMMM d, yyyy'
                            name='endDate'
                            value={values.endDate}
                            onChange={setFieldValue}
                            disabled={isAcceptedProposal}
                          />
                          {errors.endDate && touched.endDate && <Form.Text className="text-danger">
                            {errors.endDate}
                          </Form.Text>}
                        </Form.Group>
                      </Col>

                      {/* File upload — always editable, even when proposal is accepted */}
                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label>Upload Service Agreement {values.planSelected !== 'freePlan' && <span className="text-danger">*</span>}</Form.Label>
                          <br />
                          <input id="file" name="file" type="file" onChange={(event) => {
                            setFieldValue("file", event.currentTarget.files[0]);
                          }} />
                          {errors.file && touched.file && <Form.Text className="text-danger">
                            {errors.file}
                          </Form.Text>}
                        </Form.Group>
                      </Col>

                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label htmlFor="payment-mode" >Subscription Payment Mode <span className="text-danger">*</span></Form.Label><br />
                          <Form.Check
                            inline type="radio" label='Free Trial' name={'paymentChargeMode'}
                            id="freeTrialRadio" value={"FREE_TRIAL"}
                            checked={values.paymentChargeMode === "FREE_TRIAL"}
                            onChange={handleChange} disabled={isAcceptedProposal}
                          />
                          <Form.Check
                            inline type="radio" label='Deduct from Rent' name={'paymentChargeMode'}
                            id="deductFromRentRadio" value={constants.PAYMENT_CHARGE_MODE[0]}
                            checked={values.paymentChargeMode === constants.PAYMENT_CHARGE_MODE[0]}
                            onChange={handleChange} disabled={isAcceptedProposal}
                          />
                          <Form.Check
                            inline type="radio" label="Invoice Full Amount" name={'paymentChargeMode'}
                            id="invoiceAmountRadio" value={constants.PAYMENT_CHARGE_MODE[1]}
                            checked={values.paymentChargeMode === constants.PAYMENT_CHARGE_MODE[1]}
                            onChange={handleChange} disabled={isAcceptedProposal}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12}>
                        <label htmlFor='planGroupID'>Select Plan <span className="text-danger">*</span></label>
                        <div className='planGroup' id='planGroupID'>
                          <Form.Group controlId="planSelected">
                            {(values.paymentChargeMode === "FREE_TRIAL" || values.paymentChargeMode === null) &&
                              <div className="radio--card-group">
                                <div className="radio--card__item" >
                                  <input
                                    id="rateCard1" name='planSelected' type="radio" value={'freePlan'}
                                    checked={values.planSelected === 'freePlan'}
                                    onChange={
                                      async (e) => {
                                        handleChange(e);
                                        await this.handlePlanChange(e, setFieldValue, validateForm, "pmsSubscription")
                                      }
                                    }
                                    disabled={isAcceptedProposal}
                                  />
                                  <label htmlFor='rateCard1'>
                                    <Card.Body>
                                      <Card.Title>Free Trial</Card.Title>
                                      <Card.Text>
                                        INR 0 for the duration between Start &amp; End Date
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>
                              </div>}
                            {(values.paymentChargeMode === "DEDUCT_FROM_RENT") &&
                              <div className="radio--card-group">
                                <div className="radio--card__item">
                                  <input
                                    id="rateCard2" name='planSelected' type="radio" value={'eightPercentPlan'}
                                    checked={values.planSelected === 'eightPercentPlan'}
                                    onChange={
                                      async (e) => {
                                        handleChange(e);
                                        await this.handlePlanChange(e, setFieldValue, validateForm, "pmsSubscription")
                                      }
                                    }
                                    disabled={isAcceptedProposal}
                                  />
                                  <label htmlFor="rateCard2">
                                    <Card.Body>
                                      <Card.Title>8% of Monthly Rent</Card.Title>
                                      <Card.Text>
                                        Make sure the rent is flowing through Azuro app.
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>
                                <div className="radio--card__item">
                                  <input
                                    id="rateCard4" name="planSelected" type="radio" value={'fixedAmountFromRentPlan'}
                                    checked={values.planSelected === 'fixedAmountFromRentPlan'}
                                    onChange={
                                      async (e) => {
                                        handleChange(e);
                                        await this.handlePlanChange(e, setFieldValue, validateForm, "pmsSubscription")
                                      }
                                    }
                                    disabled={isAcceptedProposal}
                                  />
                                  <label htmlFor="rateCard4">
                                    <Card.Body>
                                      <Card.Title>Fixed Amount per Month</Card.Title>
                                      <Form.Group controlId="feeRateQuantity">
                                        <InputGroup className="mb-3">
                                          <FormControl
                                            name='feeRateQuantityFixed'
                                            type="text"
                                            value={values.feeRateQuantityFixed ?? ''}
                                            onChange={handleChange}
                                            aria-describedby="basic-addon1"
                                            disabled={isAcceptedProposal}
                                          />
                                          <InputGroup.Text id="basic-addon1">INR</InputGroup.Text>
                                        </InputGroup>
                                      </Form.Group>
                                      <Card.Text>
                                        Make sure the rent is flowing through Azuro app.
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>

                                {this.props.userDetails.userRoleCodes.includes('PROPERTY_MANAGEMENT_HEAD') && <div className="radio--card__item">
                                  <input
                                    id="rateCard5" name="planSelected" type="radio" value={'customPlan'}
                                    checked={values.planSelected === 'customPlan'}
                                    onChange={
                                      async (e) => {
                                        handleChange(e);
                                        await this.handlePlanChange(e, setFieldValue, validateForm, "pmsSubscription")
                                      }
                                    }
                                    disabled={isAcceptedProposal}
                                  />
                                  <label htmlFor="rateCard5">
                                    <Card.Body>
                                      <Card.Title>Custom Plan</Card.Title>
                                      <Form.Group controlId="pmsSubscription.feeRateQuantity">
                                        <InputGroup className="mb-3">
                                          <FormControl
                                            name="feeRateQuantityCustom"
                                            type="text"
                                            className="px-2"
                                            value={values.feeRateQuantityCustom ?? ''}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            aria-describedby="basic-addon1"
                                            disabled={isAcceptedProposal}
                                          />
                                          <InputGroup.Text id="basic-addon1">% of Monthly Rent</InputGroup.Text>
                                        </InputGroup>
                                      </Form.Group>
                                      <Card.Text>
                                        Make sure the rent is flowing through Azuro app.
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>}
                              </div>}

                            {values.paymentChargeMode === constants.PAYMENT_CHARGE_MODE[1] &&
                              <div className="radio--card-group">
                                <div className="radio--card__item">
                                  <input
                                    id="rateCard6" name="planSelected" type="radio" value={'fullAmountPlan'}
                                    checked={values.planSelected === 'fullAmountPlan'}
                                    onChange={
                                      async (e) => {
                                        handleChange(e);
                                        await this.handlePlanChange(e, setFieldValue, validateForm, "pmsSubscription")
                                      }
                                    }
                                    disabled={isAcceptedProposal}
                                  />
                                  <label htmlFor="rateCard6">
                                    <Card.Body>
                                      <Card.Title>Enter Amount</Card.Title>
                                      <Form.Group controlId="pmsSubscription.feeRateQuantity">
                                        <InputGroup className="mb-3">
                                          <InputGroup.Text id="basic-addon1">INR</InputGroup.Text>
                                          <FormControl
                                            name="feeRateQuantityFull"
                                            type="text"
                                            value={values.feeRateQuantityFull ?? ''}
                                            onChange={handleChange}
                                            aria-describedby="basic-addon1"
                                            disabled={isAcceptedProposal}
                                          />
                                        </InputGroup>
                                      </Form.Group>
                                      <Card.Text>
                                        The total fee for the duration of the PMS subscription
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>
                              </div>
                            }
                            {errors && errors.planSelected && touched && touched.planSelected && <Form.Text className="text-danger">
                              {errors.planSelected}
                            </Form.Text>}
                          </Form.Group>
                        </div>
                      </Col>

                      {/* TCF ID — always editable, even when proposal is accepted */}
                      {values.paymentChargeMode !== "FREE_TRIAL" &&
                        <Col xs={6}>
                          <Form.Group controlId="tcfIdentifier">
                            <Form.Label>TCF ID <span className="text-danger">*</span></Form.Label>
                            <Field
                              as={Form.Control} name="tcfIdentifier" validate={this.validateTCFId}
                              type="text" placeholder="Eg: TCF-20210315-0056" minLength="17" maxLength="17"
                              pattern={constants.tcfIdPattern} onChange={handleChange} onBlur={handleBlur}
                              value={values.tcfIdentifier}
                            />
                            {errors && errors.tcfIdentifier && touched && touched.tcfIdentifier && <Form.Text className="text-danger">
                              {errors.tcfIdentifier}
                            </Form.Text>}
                          </Form.Group>
                        </Col>
                      }
                    </Row>
                    <Row>
                      <Col xs={12} className="text-right">
                        <Button variant="secondary" className="mr-2" onClick={this.handleRenewPMSSubscriptionButtonClick}>
                          Cancel
                        </Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                          {isSubmitting ? 'Saving...' : 'Save'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )
              }
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.showMoveOutModal} onHide={() => this.handleMarkMoveOutButtonClick} centered>
          <Modal.Header closeButton>
            <Modal.Title>Mark Renewal as Move-Out</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {(() => {
              const lease = accordionData?.house?.currentLease[0];

              const canMarkMoveOut = lease?.moveOutTerminalStatus === "YES" && lease?.moveOutDate;

              return canMarkMoveOut ? (
                <>
                  <div className="alert alert-success mb-3">
                    <strong>Move-Out Completed</strong>
                  </div>

                  <p className="mb-3">
                    The tenant's Move-Out has been completed.
                    <br />
                    Are you sure you want to mark this renewal as <strong>Move-Out</strong>?
                  </p>
                </>
              ) : (
                <>
                  <div className="alert alert-warning mb-3">
                    <strong>Move-Out is not completed.</strong>
                  </div>

                  <p>
                    This renewal cannot be marked as <strong>Move-Out</strong> because the
                    tenant's Move-Out has not been completed.
                  </p>

                  <p className="mb-0">
                    Please update the <strong>Lease Profile</strong> by:
                  </p>

                  <ul className="mb-3">
                    <li>Setting <strong>Move-Out Status</strong> to <strong>Yes</strong></li>
                    <li>Adding the <strong>Move-Out Date</strong></li>
                  </ul>
                </>
              );
            })()}
          </Modal.Body>

          <Modal.Footer>
            {(() => {
              const lease = accordionData?.house?.currentLease[0];

              const canMarkMoveOut = lease?.moveOutTerminalStatus === "YES" && lease?.moveOutDate;

              return canMarkMoveOut ? (
                <>
                  <Button
                    variant="secondary"
                    onClick={this.handleMarkMoveOutButtonClick}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="danger"
                    onClick={this.handleMoveOutRenewal}
                  >
                    Mark as Move-Out
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="secondary"
                    onClick={() =>
                      this.setState({
                        showMoveOutModal: false
                      })
                    }
                  >
                    Close
                  </Button>

                  <Button
                    variant="primary"
                    onClick={() => {
                      const leaseId = accordionData?.house?.currentLease[0]?.id;
                      console.log(leaseId)
                      this.setState(
                        {
                          showMoveOutModal: false
                        },
                        //() => this.props.history.push(`/lease-profile/${leaseId}`)
                      );
                      window.open(`/lease-profile/${leaseId}`, "_blank")
                    }}
                  >
                    Go to Lease Profile
                  </Button>
                </>
              );
            })()}
          </Modal.Footer>
        </Modal>

        <Modal backdrop="static" keyboard={false} key={'m' + 1} show={this.state.showNotifyModal} onHide={this.handleNotifyButtonClick}>
          <Modal.Header closeButton>
            <Modal.Title>Notify Customer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                isNotify: null,
                isNotifyTenant: null
              }}
              validationSchema={Yup.object().shape({
                isNotify: Yup.boolean().nullable().required("notify customers is required"),
                isNotifyTenant: Yup.boolean().nullable()
                  .when("isNotify", {
                    is: true,
                    then: Yup.boolean().required("notify tenant is required"),
                    otherwise: Yup.boolean().nullable()
                  }),
              })}
              // validationSchema={cancelPMSSubscriptionSchema}
              onSubmit={async (values) => {
                const result = await pmsRenewalServices.notifyCustomer(accordionData && accordionData.id, values);
                if (result && result.status === 200) {
                  store.addNotification({
                    title: "Success!",
                    message: `Renewal Notification Initiated!`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 5000,
                      onScreen: true,
                      showIcon: true,
                      pauseOnHover: true
                    }
                  });
                  this.setState(state => ({ showNotifyModal: !state.showNotifyModal }));
                  this.getAllPMSRenewalWorks();
                }
              }
              }
            >
              {
                ({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) =>
                (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col>
                        <Form.Group controlId='isNotify'>
                          <Form.Label>Notify customer's</Form.Label>
                          <Form.Control as='select' name='isNotify'
                            onChange={(e) => {
                              const value = e.target.value === "" ? null : e.target.value === "true";

                              setFieldValue("isNotify", value);
                              if (!value) {
                                setFieldValue("isNotifyTenant", null);
                              }
                            }}
                            onBlur={handleBlur} value={values.isNotify}>
                            <option value={null}>{constants.DEFAULT_OPTION}</option>
                            <option value={true}>YES</option>
                            <option value={false}>NO</option>
                          </Form.Control>
                          {errors.isNotify && errors.isNotify && touched.isNotify && touched.isNotify && <Form.Text className='text-danger'>
                            {errors.isNotify}</Form.Text>}
                        </Form.Group>
                      </Col>
                      {values.isNotify === true && (<Col>
                        <Form.Group controlId='isNotifyTenant'>
                          <Form.Label>Notify Tenant</Form.Label>
                          <Form.Control as='select' name='isNotifyTenant' onChange={(e) =>
                            setFieldValue(
                              "isNotifyTenant",
                              e.target.value === "true" ? true : e.target.value === "false" ? false : null
                            )
                          } onBlur={handleBlur} value={values.isNotifyTenant}>
                            <option value={null}>{constants.DEFAULT_OPTION}</option>
                            <option value={true}>YES</option>
                            <option value={false}>NO</option>
                          </Form.Control>
                          {errors.isNotifyTenant && errors.isNotifyTenant && touched.isNotifyTenant && touched.isNotifyTenant && <Form.Text className='text-danger'>
                            {errors.isNotifyTenant}</Form.Text>}
                        </Form.Group>
                      </Col>)}
                    </Row>
                    <Row>
                      <Col xs={12} className="text-right">
                        <Button variant="secondary" className="mr-2" onClick={this.handleNotifyButtonClick}>
                          Cancel
                        </Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                          {isSubmitting ? 'Saving...' : 'Save'}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )
              }
            </Formik>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showViewReasonModal}
          onHide={() => this.setState({ showViewReasonModal: false })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.lostOrHold === "LOST" ? "Lost Reason Details" : "Hold Reason Details"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedLease && (
              <div>
                <p>
                  <strong>Status:</strong> {this.state.selectedLease.state}
                </p>

                {/* Show Remarks Category only for LOST */}
                {this.state.lostOrHold === "LOST" && (
                  <p>
                    <strong>Remarks Category:</strong>{" "}
                    {this.state.selectedLease.terminalRemarksCategory || "Not Available"}
                  </p>
                )}

                <p>
                  <strong>Remarks:</strong>{" "}
                  {this.state.selectedLease.terminalRemarks || "Not Available"}
                </p>

                <p>
                  <strong>Status Marked At:</strong>{" "}
                  {this.state.selectedLease.terminalStatusMarkedAt
                    ? formatDateTime(this.state.selectedLease.terminalStatusMarkedAt)
                    : "Not Available"}
                </p>

                <p>
                  <strong>Marked By:</strong>{" "}
                  {this.state.selectedLease.terminalStatusMarker?.fullName || "Not Available"}
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showViewReasonModal: false })}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          backdrop="static"
          keyboard={false}
          size="lg"
          show={this.state.showProposalModal}
          onHide={this.handlePMSProposalButtonClick}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Send Owner Acknowledgement
            </Modal.Title>
          </Modal.Header>

          <Formik
            initialValues={{
              pmsProposal: {
                houseId: accordionData?.house?.id || "",
                ownerId: undefined,
                workId: accordionData?.id || "",
                currentRent: accordionData?.house?.currentRent || "",
                revisedRent: undefined,
                maintenanceIncluded: true,
                newSubscriptionStartDate: undefined,
                newSubscriptionEndDate: undefined,
                feeRateQuantity: undefined,
                feeRateUnit: undefined,
                feePaymentInterval: undefined,
                feePaymentMechanism: undefined,
                paymentChargeMode: "FREE_TRIAL",
                status: "SENT",
                description: "",
                planSelected: undefined,
              }
            }}

            validationSchema={pmsProposalSchema}

            onSubmit={async (values, { setSubmitting }) => {
              console.log("SUBMIT");
              console.log(values);
              switch (values.pmsProposal.planSelected) {
                case "eightPercentPlan":
                  values.pmsProposal.feeRateQuantity = "8";
                  values.pmsProposal.feeRateUnit = "%";
                  values.pmsProposal.feePaymentInterval = "POST_PAID";
                  values.pmsProposal.feePaymentMechanism = "DEDUCT_FROM_RENT";
                  break;

                case "fixedAmountFromRentPlan":
                  values.pmsProposal.feeRateUnit = "ABSOLUTE";
                  values.pmsProposal.feePaymentInterval = "POST_PAID";
                  values.pmsProposal.feePaymentMechanism = "DEDUCT_FROM_RENT";
                  break;

                case "customPlan":
                  values.pmsProposal.feeRateUnit = "%";
                  values.pmsProposal.feePaymentInterval = "POST_PAID";
                  values.pmsProposal.feePaymentMechanism = "DEDUCT_FROM_RENT";
                  break;

                case "fullAmountPlan":
                  values.pmsProposal.feeRateUnit = "ABSOLUTE";
                  values.pmsProposal.feePaymentInterval = "PRE_PAID";
                  values.pmsProposal.feePaymentMechanism = "INVOICE_FULL_AMOUNT";
                  break;

                default:
                  break;
              }

              delete values.pmsProposal.planSelected;
              if (values.pmsProposal.paymentChargeMode === "FREE_TRIAL") {
                values.pmsProposal.paymentChargeMode = "";
              }

              let formData = new FormData();

              Object.keys(values.pmsProposal).forEach(key => {
                formData.append(
                  `pmsProposal[${key}]`,
                  values.pmsProposal[key]
                );
              });
              console.log(formData)
              const result = await pmsRenewalServices.createPMSProposal(formData);

              //setSubmitting(false);

              if (result && result.status === 201) {
                store.addNotification({
                  title: "Success!",
                  message: "Proposal Sent Successfully.",
                  type: "success",
                  insert: "top",
                  container: "top-right",
                  dismiss: {
                    duration: 5000,
                    onScreen: true
                  }
                });
                setSubmitting(false);
                this.setState({
                  showProposalModal: false
                });

                this.getAllPMSRenewalWorks();
              }

            }}
          >

            {({ values, errors, touched, handleSubmit, handleChange, handleBlur, setFieldValue, isSubmitting, validateForm }) => (
              <>
                {/* <pre>{JSON.stringify(errors, null, 2)}</pre>

                <pre>{JSON.stringify(values, null, 2)}</pre> */}
                <Form onSubmit={handleSubmit}>

                  <Modal.Body>
                    <h6 className="text-primary mb-3">
                      AUTO-FETCHED (READ ONLY)
                    </h6>

                    <Row>

                      <Col xs={6}>
                        <Form.Group>

                          <Form.Label>Property</Form.Label>

                          <Form.Control
                            disabled
                            value={
                              accordionData?.house?.formattedHouseName || ""
                            }
                          />

                        </Form.Group>
                      </Col>

                      <Col xs={6}>
                        <Form.Group>

                          <Form.Label>Configuration</Form.Label>

                          <Form.Control
                            disabled
                            value={
                              accordionData?.house?.bhk || ""
                            }
                          />

                        </Form.Group>
                      </Col>

                    </Row>

                    <Row>
                      <Col xs={6}>
                        <Form.Group>

                          <Form.Label>Owner <span className="text-danger">*</span></Form.Label>

                          <Form.Control
                            as="select"
                            name="pmsProposal.ownerId"
                            value={values.pmsProposal.ownerId}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >

                            <option value="">
                              Select Owner
                            </option>

                            {accordionData?.house?.owners?.map(owner => (

                              <option
                                key={owner.id}
                                value={owner.id}
                              >
                                {owner.fullName}
                                {owner.isPrimary
                                  ? " (Primary)"
                                  : ""}
                              </option>

                            ))}

                          </Form.Control>

                          {errors.pmsProposal?.ownerId &&
                            touched.pmsProposal?.ownerId && (
                              <Form.Text className="text-danger">
                                {errors.pmsProposal.ownerId}
                              </Form.Text>
                            )}

                        </Form.Group>
                      </Col>

                      <Col xs={6}>
                        <Form.Group>

                          <Form.Label>
                            Current Rent
                          </Form.Label>

                          <Form.Control
                            disabled
                            value={
                              values.pmsProposal.currentRent
                            }
                          />

                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6}>
                        <Form.Group>
                          <Form.Label>Maintenance Included<span className="text-danger">*</span></Form.Label>
                          <div>
                            <Form.Check
                              inline
                              type="radio"
                              label="Yes"
                              id="maintenanceIncludedYes"
                              name="pmsProposal.maintenanceIncluded"
                              checked={values.pmsProposal.maintenanceIncluded === true}
                              onChange={() =>
                                setFieldValue("pmsProposal.maintenanceIncluded", true)
                              }
                            />

                            <Form.Check
                              inline
                              type="radio"
                              label="No"
                              id="maintenanceIncludedNo"
                              name="pmsProposal.maintenanceIncluded"
                              checked={values.pmsProposal.maintenanceIncluded === false}
                              onChange={() =>
                                setFieldValue("pmsProposal.maintenanceIncluded", false)
                              }
                            />
                          </div>
                        </Form.Group>
                      </Col>

                    </Row>

                    <hr />

                    <h6 className="text-primary mb-3">
                      EDITABLE (MANDATORY)
                    </h6>

                    <Row>
                      <Col xs={6}>

                        <Form.Group>

                          <Form.Label>
                            Revised Rent <span className="text-danger">*</span>
                          </Form.Label>

                          <Form.Control
                            name="pmsProposal.revisedRent"
                            value={
                              values.pmsProposal.revisedRent
                            }
                            onChange={handleChange}
                          />
                          {errors.pmsProposal && errors.pmsProposal.revisedRent && touched.pmsProposal && touched.pmsProposal.revisedRent && <Form.Text className="text-danger">
                            {errors.pmsProposal.revisedRent}
                          </Form.Text>}
                        </Form.Group>
                      </Col>

                      <Col xs={6}>
                        <Form.Group controlId="pmsProposal.newSubscriptionStartDate">
                          <DatePickerField
                            className='form-control'
                            autoComplete='off'
                            label='Start Date'
                            isMandatory={true}
                            dateFormat='MMMM d, yyyy'
                            name='pmsProposal.newSubscriptionStartDate'
                            value={values.pmsProposal.newSubscriptionStartDate}
                            onChange={setFieldValue}
                          />
                          {errors.pmsProposal && errors.pmsProposal.newSubscriptionStartDate && touched.pmsProposal && touched.pmsProposal.newSubscriptionStartDate && <Form.Text className="text-danger">
                            {errors.pmsProposal.newSubscriptionStartDate}
                          </Form.Text>}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={6}>
                        <Form.Group controlId="pmsProposal.newSubscriptionEndDate">
                          <DatePickerField
                            className='form-control'
                            autoComplete='off'
                            label='End Date'
                            isMandatory={true}
                            dateFormat='MMMM d, yyyy'
                            name='pmsProposal.newSubscriptionEndDate'
                            value={values.pmsProposal.newSubscriptionEndDate}
                            onChange={setFieldValue}
                          />
                          {errors.pmsProposal && errors.pmsProposal.newSubscriptionEndDate && touched.pmsProposal && touched.pmsProposal.newSubscriptionEndDate && <Form.Text className="text-danger">
                            {errors.pmsProposal.newSubscriptionEndDate}
                          </Form.Text>}
                        </Form.Group>
                      </Col>

                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label htmlFor="payment-mode" >Subscription Payment Mode <span className="text-danger">*</span></Form.Label><br />
                          <Form.Check inline type="radio" label='Free Trial' defaultChecked name={'pmsProposal.paymentChargeMode'} id="freeTrialRadio" value={"FREE_TRIAL"} onChange={handleChange} />
                          <Form.Check inline type="radio" label='Deduct from Rent' name={'pmsProposal.paymentChargeMode'} id="deductFromRentRadio" value={constants.PAYMENT_CHARGE_MODE[0]} onChange={handleChange} />
                          <Form.Check inline type="radio" label="Invoice Full Amount" name={'pmsProposal.paymentChargeMode'} id="invoiceAmountRadio" value={constants.PAYMENT_CHARGE_MODE[1]} onChange={handleChange} />
                        </Form.Group>
                      </Col>
                      <Col xs={12}>
                        <label htmlFor='planGroupID'>Select Plan <span className="text-danger">*</span></label>
                        <div className='planGroup' id='planGroupID'>
                          <Form.Group controlId="pmsProposal.planSelected">
                            {/* value.planSelected */}
                            {(values.pmsProposal.paymentChargeMode === "FREE_TRIAL" || values.pmsProposal.paymentChargeMode === null) &&
                              <div className="radio--card-group">
                                <div className="radio--card__item" >
                                  <input id="rateCard1" name='pmsProposal.planSelected' type="radio" value={'freePlan'} onChange={
                                    async (e) => {
                                      handleChange(e);
                                      await this.handlePlanChange(e, setFieldValue, validateForm, "pmsProposal")
                                    }
                                  } />
                                  <label htmlFor='rateCard1'>
                                    <Card.Body>
                                      <Card.Title>Free Trial</Card.Title>
                                      <Card.Text>
                                        INR 0 for the duration between Start &amp; End Date
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>
                              </div>}
                            {(values.pmsProposal.paymentChargeMode === "DEDUCT_FROM_RENT") &&
                              <div className="radio--card-group">
                                <div className="radio--card__item">
                                  <input id="rateCard2" name='pmsProposal.planSelected' type="radio" value={'eightPercentPlan'} onChange={
                                    async (e) => {
                                      handleChange(e);
                                      await this.handlePlanChange(e, setFieldValue, validateForm, "pmsProposal")
                                    }
                                  } />
                                  <label htmlFor="rateCard2">
                                    <Card.Body>
                                      <Card.Title>8% of Monthly Rent</Card.Title>
                                      <Card.Text>
                                        Make sure the rent is flowing through Azuro app.
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>
                                <div className="radio--card__item">
                                  <input id="rateCard4" name="pmsProposal.planSelected" type="radio" value={'fixedAmountFromRentPlan'} onChange={
                                    async (e) => {
                                      handleChange(e);
                                      await this.handlePlanChange(e, setFieldValue, validateForm, "pmsProposal")
                                    }
                                  } />
                                  <label htmlFor="rateCard4">
                                    <Card.Body>
                                      <Card.Title>Fixed Amount per Month</Card.Title>
                                      <Form.Group controlId="pmsProposal.feeRateQuantity">
                                        <InputGroup className="mb-3">
                                          <FormControl name='pmsProposal.feeRateQuantity' type="text" onChange={handleChange} aria-describedby="basic-addon1" />
                                          <InputGroup.Text id="basic-addon1">INR</InputGroup.Text>
                                        </InputGroup>
                                      </Form.Group>
                                      <Card.Text>
                                        Make sure the rent is flowing through Azuro app.
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>

                                {this.props.userDetails.userRoleCodes.includes('PROPERTY_MANAGEMENT_HEAD') && <div className="radio--card__item">
                                  <input id="rateCard5" name="pmsProposal.planSelected" type="radio" value={'customPlan'} onChange={
                                    async (e) => {
                                      handleChange(e);
                                      await this.handlePlanChange(e, setFieldValue, validateForm, "pmsProposal")
                                    }
                                  } />
                                  <label htmlFor="rateCard5">
                                    <Card.Body>
                                      <Card.Title>Custom Plan</Card.Title>
                                      <Form.Group controlId="pmsProposal.feeRateQuantity">
                                        <InputGroup className="mb-3">
                                          <FormControl name="pmsProposal.feeRateQuantity" type="text" className="px-2" onChange={handleChange} onBlur={handleBlur} aria-describedby="basic-addon1" />
                                          <InputGroup.Text id="basic-addon1">% of Monthly Rent</InputGroup.Text>
                                        </InputGroup>
                                      </Form.Group>
                                      <Card.Text>
                                        Make sure the rent is flowing through Azuro app.
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>}
                              </div>}

                            {values.pmsProposal.paymentChargeMode === constants.PAYMENT_CHARGE_MODE[1] &&
                              <div className="radio--card-group">
                                <div className="radio--card__item">
                                  <input id="rateCard6" name="pmsProposal.planSelected" type="radio" value={'fullAmountPlan'} onChange={
                                    async (e) => {
                                      handleChange(e);
                                      await this.handlePlanChange(e, setFieldValue, validateForm, "pmsProposal")
                                    }
                                  } />
                                  <label htmlFor="rateCard6">
                                    <Card.Body>
                                      <Card.Title>Enter Amount</Card.Title>
                                      <Form.Group controlId="feeRateQuantity">
                                        <InputGroup className="mb-3">
                                          <InputGroup.Text id="basic-addon1">INR</InputGroup.Text>
                                          <FormControl name="pmsProposal.feeRateQuantity" type="text" onChange={handleChange} aria-describedby="basic-addon1" />
                                        </InputGroup>
                                      </Form.Group>
                                      <Card.Text>
                                        The total fee for the duration of the PMS subscription
                                      </Card.Text>
                                    </Card.Body>
                                  </label>
                                </div>
                              </div>
                            }
                            {errors && errors.pmsProposal?.planSelected && touched && touched.pmsProposal?.planSelected && <Form.Text className="text-danger">
                              {errors.pmsProposal?.planSelected}
                            </Form.Text>}
                          </Form.Group>
                        </div>
                      </Col>

                    </Row>
                    <Row>

                      <Col xs={12}>

                        <Form.Group>

                          <Form.Label>
                            Remarks / Notes
                          </Form.Label>

                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="pmsProposal.description"
                            value={
                              values.pmsProposal.description
                            }
                            onChange={handleChange}
                          />

                        </Form.Group>

                      </Col>

                    </Row>

                  </Modal.Body>

                  <Modal.Footer>

                    <Button
                      variant="secondary"
                      onClick={this.handlePMSProposalButtonClick}
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting
                        ? "Sending..."
                        : "Send"}
                    </Button>

                  </Modal.Footer>

                </Form>
              </>
            )}

          </Formik>

        </Modal>
      </>
    )
  }
}


const mapStateToProps = state => ({
  userDetails: state.auth && state.auth.user
});

export default
  connect(
    mapStateToProps,
    null
  )(PMSRenewals);